import { registerGoogleFont } from "@client/lib/fonts";
import { mergeCompositeValues } from "@client/lib/settings";
import { STYLE_SHEET_IDS } from "@client/lib/styleSheet";
import { type CompositeSettings } from "@client/types";
import { joinDefined } from "@common/lib/misc";
import { createSelector } from "reselect";
import {
  getColorSelector,
  getCompositeSettingSelector,
  makeTextStyleSheetColorSelector,
  makeTextStyleSheetSettingSelector
} from ".";

export const getTextSettingSelector = (target: string, prefix?: string) =>
  getCompositeSettingSelector<CompositeSettings.Text>(target, "text", prefix);

export const getInheritedTextSettingSelector = (target: string, prefix?: string) => {
  const styleSheetSettingSelector = makeTextStyleSheetSettingSelector(target, prefix);
  const settingSelector = getTextSettingSelector(target, prefix);
  const colorSelector = makeTextStyleSheetColorSelector(target, prefix);

  return createSelector(
    [styleSheetSettingSelector, settingSelector, colorSelector],
    (styleSheetSetting, setting, color): CompositeSettings.Text => {
      const result = {
        ...mergeCompositeValues<CompositeSettings.Text>(styleSheetSetting ?? {}, setting!),
        s_text: STYLE_SHEET_IDS.custom,
        color
      };

      // TODO: find a better place
      registerGoogleFont(setting?.font);

      return result;
    }
  );
};

export const getInheritedTextHoverSettingSelector = (target: string, prefix?: string) => {
  const textSelector = getInheritedTextSettingSelector(target, prefix);
  const hoverColorSelector = getColorSelector(target, "hoverColor", joinDefined(".", prefix, "text"), "none");

  return createSelector(
    [textSelector, hoverColorSelector],
    (text, hoverColor): CompositeSettings.TextHover => ({
      ...text,
      hoverColor
    })
  );
};
